import {
  Component,
  ChangeDetectionStrategy,
  computed,
  inject,
  signal,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SplashScreen } from './common/ui/elements/splash-screen/splash-screen';
import { HealthService } from '@nebalkon-workspace/health';
import { environment } from '@nebalkon-workspace/environments';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { Dialog } from '@angular/cdk/dialog';
import { HealthCheckErrorDialogComponent } from './health-check-error-dialog/health-check-error-dialog';
import { PendingPickupAddressSyncService } from './common/services/pending-pickup-address/pending-pickup-address.sync.service';
import { AppBootstrapService } from './common/services/app-bootstrap.service';
import { DeepLinkService } from './services/deep-link.service';
import { PaymentBrowserService } from './services/payment-browser.service';
import { initializeTelegramWebApp } from './common/utils/telegram-mini-app';
import { KeyboardUiService } from './common/services/keyboard-ui.service';
import { NotSystemNotification } from '@nebalkon-workspace/ui-kit';
import { CurrentUrlService } from '@nebalkon-workspace/core';

@Component({
  imports: [RouterModule, SplashScreen, NotSystemNotification],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  readonly #healthService = inject(HealthService);
  readonly #bootstrap = inject(AppBootstrapService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #dialog = inject(Dialog);
  readonly #keyboardUi = inject(KeyboardUiService);
  readonly #currentUrl = inject(CurrentUrlService).currentUrl;

  protected readonly cabinetShellActive = computed(() => {
    const url = this.#currentUrl();
    return url.startsWith('/client') || url.startsWith('/stuff');
  });

  protected readonly splashScreenVisible = signal(true);

  constructor() {
    initializeTelegramWebApp();
    inject(PendingPickupAddressSyncService);
    inject(DeepLinkService);
    inject(PaymentBrowserService);
  }

  public ngOnInit(): void {
    this.#keyboardUi.attach(this.#destroyRef);
    this.#healthService
      .check(environment.apiUrl, 8000)
      .pipe(take(1), takeUntilDestroyed(this.#destroyRef))
      .subscribe((ok) => {
        if (ok) {
          this.splashScreenVisible.set(false);
          window.setTimeout(() => this.#bootstrap.splashHidden.set(true), 320);
        } else {
          this.#dialog.open(HealthCheckErrorDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-dark-backdrop',
            panelClass: 'health-check-error-dialog-panel',
            width: '320px',
            maxWidth: '90vw',
          });
        }
      });
  }
}
